
import type { Product } from './types';

export const proficarProducts: Product[] = [
  {
    id: 'shad1',
    shopId: '13',
    name: 'PROFI-CAR FS SAE 5W-30',
    brand: 'PROFI-CAR',
    price: 140, // UPDATED
    image: 'https://www.profi-car.com/files/public/label-13304-profi-car-fs-sae-5w-30-2025-03-27-v1-074ad_3112.png?1747898003', // updated image
    description: 'Synthetic high-performance engine oil for maximum protection and efficiency.',
    category: 'oil',
  },
  {
    id: 'shad2',
    shopId: '13',
    name: 'PROFI-CAR Endurance SAE 10W-40',
    brand: 'PROFI-CAR',
    price: 120, // UPDATED
    image: 'https://www.profi-car.com/files/public/label-16844-endurance-10w-40-2025-04-17-v1-63f09_1490.png?1747898859', // updated image
    description: 'Durable semi-synthetic engine oil for extended performance.',
    category: 'oil',
  },
  {
    id: 'shad3',
    shopId: '13',
    name: 'PROFI-CAR ULTRA PROTECT 5 Diesel, 250 ml',
    brand: 'PROFI-CAR',
    price: 60,
    image: 'https://www.profi-car.com/files/public/label-16791-ultra-protect-5-diesel-023e6.png', // placeholder, change if needed
    description: 'High-performance diesel additive for optimum protection and cleaning.',
    category: 'additive',
  },
  {
    id: 'shad4',
    shopId: '13',
    name: 'PROFI-CAR ULTRA PROTECT 5 gasoline, 250 ml',
    brand: 'PROFI-CAR',
    price: 60,
    image: 'https://www.profi-car.com/files/public/label-16792-ultra-protect-5-benzin-c7c28.png', // placeholder, change if needed
    description: 'High-performance gasoline additive for superior cleaning and engine protection.',
    category: 'additive',
  },
];
